const r=r=>r instanceof Error?r:new Error("string"==typeof r?r:JSON.stringify(r));export{r as normalizeError};
